<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import { useProjectStore } from '@/stores/project'
import { useCalculationStore } from '@/stores/calculation'
import { useHardwareProfileStore } from '@/stores/hardwareProfile'
import { useProjectUserStore } from '@/stores/projectUser'
import { useAuthorizationStore } from '@/stores/authorization'
import { useDjangoAuthStore } from '@/stores/authDjango'
import { storeToRefs } from 'pinia'
import _ from 'lodash'
import { AppBackground, ProjectHeaderImage } from '@haskoning/vue-component-library'
import type { ProjectUserType } from '@/stores/type/projectUser.type'
import { useProjectUserPermissions } from '@/composables/useProjectUserPermissions'
import router from '@/router'

const route = useRoute()

const projectStore = useProjectStore()
const calculationStore = useCalculationStore()
const hardwareProfileStore = useHardwareProfileStore()

const authStore = useDjangoAuthStore()
const projectUserStore = useProjectUserStore()
const authorizationStore = useAuthorizationStore()
authorizationStore.setCurrentRole([])

const { currentItem: currentProjectItem } = storeToRefs(projectStore)
const { fetchLoading: calculationFetchLoading } = storeToRefs(calculationStore)
const { user: currentUser } = storeToRefs(authStore)
const { canViewProjectUsers } = useProjectUserPermissions()

onMounted(async () => {
  calculationFetchLoading.value = true
  if (!currentProjectItem.value || _.isEmpty(currentProjectItem.value)) {
    await projectStore.fetchOptions()
    const projectId = route.params.id as string
    await projectStore.fetchItem(parseInt(projectId))

    if (!currentProjectItem.value || _.isEmpty(currentProjectItem.value)) {
      await router.push({ name: 'not-found' })
    }
  }

  if (currentProjectItem.value) {
    const { id } = currentProjectItem.value

    if (id) {
      await authorizationStore.fetchItems()

      const currentProjectUser = currentProjectItem.value
        .current_project_user as ProjectUserType | null
      authorizationStore.setCurrentRole(
        [currentUser.value?.role, currentProjectUser?.role].filter(Boolean) as number[]
      )

      if (canViewProjectUsers.value) {
        await projectUserStore.fetchItems({ search: id })
      } else {
        projectUserStore.resetState()
      }

      await calculationStore.fetchOptions()
      await hardwareProfileStore.fetchAvailable(id)
      await calculationStore.fetchItems({ search: id })
      calculationStore.setSelectedItems([])
    }
  }

  calculationFetchLoading.value = false
})

onUnmounted(() => {
  projectStore.resetAll()
  calculationStore.resetAll()
  hardwareProfileStore.resetAll()
})
</script>
<template>
  <div style="display: flex; flex-direction: column" class="fill-height">
    <ProjectHeaderImage :lazy-src="'/header_lazy.jpg'" :src="'/header.jpeg'" />
    <AppBackground>
      <router-view></router-view>
    </AppBackground>
  </div>
</template>

<style scoped></style>
